import { IUpdateAfastamentoUseCase } from "../../../presentation/useCases/update/update_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateAfastamentoUseCase
 */

export class UpdateAfastamentoUseCase implements IUpdateAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateAfastamento(
    idFuncionario: number,
    idMotivoAfastamento: number,
    dataInicio: Date,
    dataTermino: Date,
    observacao: string,
  ): Promise<void> {
    await this.repository.updateAfastamento(
      idFuncionario,
      idMotivoAfastamento,
      observacao,
      dataInicio,
      dataTermino,
    );
  }
}